const MenuConfig: any = [
    {
        heading: 'aside.menu.categories.main',
        pages: [
            {
                heading: 'aside.menu.pages.map',
                route: '/',
                fontIcon: 'bi-map',
            },
            {
                heading: 'aside.menu.pages.assetsMap',
                route: '/assets-map',
                fontIcon: 'bi-map-fill',
                roles: ['ROLE_ASSET'],
            },
            {
                heading: 'aside.menu.pages.assetGroups',
                fontIcon: 'bi-diagram-2',
                roles: ['ROLE_ASSET'],
                sub: [
                    {
                        heading: 'aside.menu.pages.assetGroupsManage',
                        route: '/asset-groups',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.assetGroupsWithLocation',
                        route: '/asset-groups/with-location',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.assetSchemes',
                        route: '/asset-schemes',
                        roles: ['ROLE_ASSET'],
                    },
                ]
            },
            {
                heading: 'aside.menu.categories.wirepas',
                fontIcon: 'bi-broadcast-pin',
                roles: ['ROLE_ASSET'],
                wirepasOnly: true,
                sub: [
                    {
                        heading: 'aside.menu.pages.wirepasLocations',
                        route: '/wirepas-locations',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.wirepasAssets',
                        route: '/wirepas-assets',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.infrastructure',
                        route: '/infrastructure',
                        roles: ['ROLE_ADMIN', 'ROLE_BOSS', 'ROLE_ASSET_OWNER', 'ROLE_ASSET_ADMIN'],
                    },
                ]
            },
            {
                heading: 'aside.menu.pages.vehicles',
                route: '/vehicles',
                fontIcon: 'bi-truck',
            },
            {
                heading: 'aside.menu.pages.assets',
                fontIcon: 'bi-broadcast-pin',
                roles: ['ROLE_ASSET'],
                sub: [
                    {
                        heading: 'aside.menu.pages.assetsList',
                        route: '/assets',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.assetsGroupsList',
                        route: '/assets/groups',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.assetModbusParamSet',
                        route: '/assets/modbus-params',
                        roles: ['ROLE_MODUS_PARAMS_SET'],
                        parameters: ['HAS_MODBUS_ASSETS'],
                    },
                ]
            },
            {
                heading: 'aside.menu.pages.userAssets',
                fontIcon: 'bi-person-badge',
                roles: ['ROLE_ASSET'],
                sub: [
                    {
                        heading: 'aside.menu.pages.userAssetsList',
                        route: '/user-assets',
                        roles: ['ROLE_ASSET'],
                    }
                ]
            },
            {
                heading: 'aside.menu.pages.sentGeo',
                route: '/sent-geo',
                fontIcon: 'bi-compass'
            },
            {
                heading: 'aside.menu.pages.history',
                route: '/history',
                fontIcon: 'bi-clock-history'
            },
            {
                heading: 'aside.menu.pages.reports',
                route: '/reports',
                fontIcon: 'bi-graph-up-arrow'
            },
            {
                heading: 'aside.menu.pages.tachographFiles',
                route: '/tachograph-files',
                fontIcon: 'bi-download'
            },
            {
                heading: 'aside.menu.pages.tachoAnalysis',
                route: '/tacho-analysis',
                fontIcon: 'bi-file-earmark-bar-graph'
            },
            {
                heading: 'aside.menu.pages.geofencing',
                route: '/geofencing',
                fontIcon: 'bi-bullseye'
            },
            {
                heading: 'aside.menu.pages.users',
                route: '/users',
                fontIcon: 'bi-people',
                roles: ['ROLE_ADMIN', 'ROLE_BOSS'],
                visibleFor: ['admin', 'boss'],
            },
            {
                heading: 'aside.menu.pages.notifications',
                // route: '/notifications',
                fontIcon: 'bi-bell',
                sub: [
                    {
                        heading: 'aside.menu.pages.notificationsHistory',
                        route: '/notifications/history',

                    },
                    {
                        heading: 'aside.menu.pages.notificationSettings',
                        route: '/notifications/settings',
                    },
                    {
                        heading: 'aside.menu.pages.assetNotificationRules',
                        route: '/notifications/asset-rules',
                        roles: ['ROLE_ASSET'],
                    },
                    {
                        heading: 'aside.menu.pages.assetNotificationHistory',
                        route: '/notifications/asset-history',
                        roles: ['ROLE_ASSET'],
                    }
                ]
            },
            {
                heading: 'aside.menu.pages.tokenManagement',
                route: '/token-management',
                fontIcon: 'bi-key',
                roles: ['ROLE_ADMIN', 'ROLE_BOSS'],
                visibleFor: ['admin', 'boss'],
            }
        ]
    }
]

export default MenuConfig
